import React from 'react';
import { Star } from 'lucide-react';
import ColorAmbient from '../components/ColorAmbient';
import PrinterStrip from '../components/PrinterStrip';
import RegistrationMark from '../components/RegistrationMark';
import VideoTestimonials from '../components/VideoTestimonials';

const TestimonialsPage = () => {
  return (
    <main className="pt-28 pb-24 bg-white min-h-screen relative overflow-hidden">
      <ColorAmbient variant="cool" intensity="medium" />

      {/* Registration marks */}
      <RegistrationMark className="absolute top-24 left-6 opacity-40" size={24} />
      <RegistrationMark className="absolute top-24 right-6 opacity-40" size={24} />

      {/* Hero */}
      <section className="container-pn mb-6 relative">
        <div className="max-w-3xl">
          <p className="text-xs uppercase tracking-[0.3em] text-[#FF4E50] font-bold mb-3">Testimonials</p>
          <h1 className="text-5xl md:text-7xl font-black text-[#050F2E] tracking-tight leading-[0.95]">
            Trusted by{' '}
            <span className="italic font-serif pn-gradient-text">
              printers
            </span>{' '}
            worldwide
          </h1>
          <p className="mt-6 text-lg text-slate-600">
            Watch professionals share how ProofNation makes their technology work for them.
          </p>
          <div className="mt-8 flex items-center gap-6">
            <div>
              <p className="text-4xl font-black text-[#0A2A63]">5.0</p>
              <div className="flex items-center gap-0.5 mt-1">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={`hero-star-${i}`} className="h-4 w-4 fill-[#FF4E50] text-[#FF4E50]" />
                ))}
              </div>
            </div>
            <div className="border-l border-slate-200 pl-6">
              <p className="text-4xl font-black text-[#0A2A63]">+400</p>
              <p className="text-xs uppercase tracking-widest text-slate-500 mt-1 font-bold">Happy customers</p>
            </div>
          </div>
          <div className="mt-8 max-w-md">
            <PrinterStrip className="opacity-90" />
          </div>
        </div>
      </section>

      {/* Video grid (all published) */}
      <VideoTestimonials showHeader={false} />

      {/* CTA */}
      <section className="container-pn mt-4">
        <div className="relative rounded-3xl bg-[#050F2E] text-white p-10 md:p-14 overflow-hidden">
          <div className="absolute -top-24 -right-24 h-80 w-80 rounded-full bg-[#FF4E50]/20 blur-3xl" />
          <div className="relative grid md:grid-cols-2 gap-8 items-center">
            <div>
              <p className="text-xs uppercase tracking-[0.3em] text-[#FF4E50] font-bold mb-3">Ready to join them?</p>
              <h2 className="text-3xl md:text-4xl font-black tracking-tight">Become the next ProofNation success story.</h2>
            </div>
            <div className="flex md:justify-end">
              <a href="/contact" className="inline-flex items-center gap-2 bg-[#FF4E50] text-[#050F2E] font-bold rounded-full px-7 h-12 hover:bg-[#FF7273] transition-colors">
                Talk to a specialist →
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default TestimonialsPage;
